import CheckboxListFilter, {
  type CheckboxListFilterProps,
} from '~/components/common/filters/CheckboxListFilter'
import i18n from '~/locales/i18n'

const Options = [
  {
    id: 'true',
    name: i18n.t('Admin:APPOINTMENT_CONFIGURATION.DROP_OFF_ALLOWED'),
  },
  {
    id: 'false',
    name: i18n.t('Admin:APPOINTMENT_CONFIGURATION.DROP_OFF_NOT_ALLOWED'),
  },
]

export interface AppointmentTypeDropOffFilterProps extends CheckboxListFilterProps {}

const AppointmentTypeDropOffFilter = (
  props: AppointmentTypeDropOffFilterProps,
) => (
  <CheckboxListFilter
    clearEmptyFilters
    singleSelection
    includeSearch={false}
    items={Options}
    {...props}
  />
)

export default AppointmentTypeDropOffFilter
